export default __webpack_public_path__ + "static/media/agenda.065ac115.png";